import React from 'react'

function ScheduleIcon({ colorCode }) {
    return (
        <svg className="MuiSvgIcon-root" viewBox="0 0 20 22" style={{ fill: 'none' }}>
            <path fillRule="evenodd" clipRule="evenodd" d="M18.1429 13.0635H12.1429V5.30839L18.1429 13.0635ZM3.57143 5.73923C1 10.0476 1 13.0635 1 13.0635H8.71429C8.71429 13.0635 7.85714 11.771 7.85714 7.89342C7.85714 4.01587 8.71429 1 8.71429 1C8.71429 1 6.14286 1.43084 3.57143 5.73923Z" stroke={colorCode} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ScheduleIcon
